'use client'

import { Divider } from '@macarongfactory/web-ui'

import CarStoryTabError from './CarStoryTabError'
import CarStoryTabLoading from './CarStoryTabLoading'
import CuratedSwiperSection from './CuratedSwiperSection'
import TopicContentsSection from './TopicContentsSection'
import {
  carStoryTracking,
  toCuratedItem,
  toTopicContentItem,
  toTopicFilters,
} from '../lib'
import {
  MYCLE_CONTENT_MENU,
  MYCLE_CONTENT_SERIES_CODE,
  useCarStoryTabPage,
} from '../model'

const CarStoryDrivePage = () => {
  const {
    selectedSort,
    setSelectedSort,
    selectedCategoryId,
    setSelectedCategoryId,
    seriesData,
    categoriesData,
    contentsItems,
    isLoading,
    isError,
    retry,
    isContentsLoading,
    isContentsError,
    refetchContents,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetchNextPageError,
  } = useCarStoryTabPage({
    menu: MYCLE_CONTENT_MENU.DRIVE,
    seriesCode: MYCLE_CONTENT_SERIES_CODE.BEGINNER,
    onPageView: carStoryTracking.showDrivePage,
  })

  if (isLoading) return <CarStoryTabLoading />
  if (isError) return <CarStoryTabError onRetry={retry} />

  const curatedItems = (seriesData?.content ?? []).map(toCuratedItem)
  const topicItems = contentsItems.map(toTopicContentItem)
  const topicFilters = toTopicFilters(categoriesData ?? [])

  return (
    <div>
      <CuratedSwiperSection
        title='슬기로운 초보 생활'
        description='초보 운전자를 위한 가이드'
        items={curatedItems}
        onCardShow={(item, index) =>
          carStoryTracking.showDriveTopContentCard(item.title, index)
        }
        onCardClick={(item, index) =>
          carStoryTracking.clickDriveTopContentCard(item.title, index)
        }
        onFirstSwipe={carStoryTracking.scrollDriveTopContents}
      />
      <Divider.Horizontal strokeWidth='stroke-width-x10' />
      <TopicContentsSection
        filters={topicFilters}
        items={topicItems}
        isContentsLoading={isContentsLoading}
        isContentsError={isContentsError}
        onContentsRetry={refetchContents}
        selectedSort={selectedSort}
        selectedCategoryId={selectedCategoryId}
        onCategoryChange={setSelectedCategoryId}
        onSortChange={setSelectedSort}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isFetchNextPageError={isFetchNextPageError}
        onFetchNextPage={fetchNextPage}
        tracking={{
          onSortClick: carStoryTracking.clickDriveSortFilter,
          onChipShow: carStoryTracking.showDriveTopicChip,
          onChipClick: carStoryTracking.clickDriveTopicChip,
          onChipScroll: carStoryTracking.scrollDriveTopicChips,
          onCardShow: (item, selectedFilter) =>
            carStoryTracking.showDriveTopicCard(item.title, selectedFilter),
          onCardClick: (item, selectedFilter) =>
            carStoryTracking.clickDriveTopicCard(item.title, selectedFilter),
        }}
      />
    </div>
  )
}

export default CarStoryDrivePage
